import { fetchJsonByGet, fetchJsonByPost, fetchJsonByPut, noResponseDelete } from './execute';
import { fromCompound, toCompound } from '../converters/compoundConverter';
import { extractType, getParams } from '../reducers/analyticsApp';

const getSegmentsInfo = (state) => {
  const typeExtractor = (event, field) => extractType(state, event, field);

  return { typeExtractor };
};

export const fetchSegments = () => (dispatch, getState) => {
  const state = getState();
  const { typeExtractor } = getSegmentsInfo(state);

  return fetchJsonByGet('/segments/list?full=true', getParams(state)).then((response) => ({
    segments: response.map((r) => fromCompound(r, typeExtractor)),
  }));
};

export const deleteSegment = (id) => (dispatch, getState) =>
  noResponseDelete(`/segments/${id}`, getParams(getState())).then(() => ({ id }));

export const updateSegment = (segment, id) => (dispatch, getState) => {
  const state = getState();
  const { typeExtractor } = getSegmentsInfo(state);

  return fetchJsonByPut('/segments', toCompound(segment), getParams(state)).then((response) => ({
    id,
    segment: fromCompound(response, typeExtractor),
  }));
};

export const createSegment = (segment) => (dispatch, getState) => {
  const state = getState();
  const { typeExtractor } = getSegmentsInfo(state);

  return fetchJsonByPost('/segments', toCompound(segment), getParams(state)).then((response) => ({
    segment: fromCompound(response, typeExtractor),
  }));
};
